import { MedicalCottonSwabIcon } from './MedicalCottonSwabIcon';

/**
 * author: Google
 * id EC9D77A4-739A-4641-BE6C-86050DD25FFE
 * name medical-cotton-swab
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/medical-cotton-swab.svg
 * tags
 * - Medical / Hospital 
 */
export const CovidTestIcon = MedicalCottonSwabIcon;
export default CovidTestIcon